/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f5d9c6c3017329a5ca7a7e88b5c64b272e14a968";
